define(
	'app/ui/charts/charts',[
		'jquery',

		'chartjs',
		'templayed',

		'text!templates/chart-table.html'
	],

	function ($, Chart, templayed, tableTemplate) {
		var selectors = {
			chart: '.js-chart',
			data: '.js-chart-data',
			canvas: '.js-chart-canvas',
			table: '.js-chart-table'
		};

		var dataSelectors = {
			id: 'chart-id'
		};

		var colours = [
			'#ffb700',
			'#79a342',
			'#b72d25',
			'#f15922',
			'#fada51',
			'#1363b4',
			'#7d489d',
			'#d31005',
			'#87d1d1'
		];

		// Templayed doesn't like carriage returns
		tableTemplate = tableTemplate.replace(/\r/g, '');

		var module = {
			init: function () {
				var $charts = $(selectors.chart);

				$charts.each(module._initChart);
			},

			_initChart: function (i, $chart) {
				$chart = $($chart);

				var data = module._getData($chart);
				data = module._transformData(data);

				var chart;

				if (!data) {
					console.debug('ERROR: No data could be found for chart', $chart);
					return false;
				}

				chart = module._createChart($chart, data);
				module._chartResize(chart);

				module._createTable($chart, data);
			},

			_getData: function ($chart) {
				var id = $chart.data(dataSelectors.id);
				var data = window.chartData[id];

				return data;
			},

			_createChart: function ($chart, data) {
				var $canvas = $chart.find(selectors.canvas);
				var context = $canvas[0].getContext('2d');

				var chart = new Chart(context, data);

				return chart;
			},

			_createTable: function ($chart, data) {
				var $table = $chart.find(selectors.table);
				var tableMarkup = templayed(tableTemplate)(data);

				$table.html(tableMarkup);
			},

			_transformData: function (data) {
				data.options = data.options || {};

				data.options.maintainAspectRatio = false;
				data.options.onResize = module._chartResize;
				data.options.tooltips = {
					callbacks: {
						label: function (thisTooltip, thisData) {
							return thisData.labels[thisTooltip.index];
						},
						title: function (thisTooltip, thisData) {
							var dataset = thisData.datasets[thisTooltip[0].datasetIndex];
							var value = module._formatNumber(dataset.data[thisTooltip[0].index]);
							return value;
						}
					},
					caretSize: 0,
					cornerRadius: 0,
					displayColors: false,
					borderWidth: 1,
					borderColor: 'rgba(204, 204, 204, 1)',
					titleFontFamily: '"Montserrat", sans-serif',
					titleFontSize: 16,
					titleFontColor: 'rgba(0, 0, 0, 1)',
					bodyFontFamily: '"Roboto", Arial, Helvetica, sans-serif',
					bodyFontColor: 'rgba(0, 0, 0, 1)',
					backgroundColor: 'rgba(255, 255, 255, 1)'
				};

				data.options.legend = {
					position: 'bottom',
					labels: {
						boxWidth: 12,
						padding: 20
					}
				};

				data = module._separateDatasetLabels(data);

				switch (data.type) {
					case 'bar':
						data = module.bar._transformData(data);
						break;
					case 'doughnut':
						data = module.doughnut._transformData(data);
						break;
					default:
						console.debug('ERROR: Unrecognised chart type: ', data.type);
						break;
				}

				return data;
			},

			_formatNumber: function (num) {
				if (typeof (parseInt(num, 10)) === 'number') {
					return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
				} else {
					return num;
				}
			},

			_chartResize: function (chart, size) {
				var canvas = chart.canvas;
				var aspectRatio = 2;
				var minHeight = 350;

				if (typeof size === 'undefined') {
					size = {
						width: canvas.width,
						height: canvas.height
					};
				}

				canvas.parentNode.style.width = '100%';
				canvas.parentNode.style.height = Math.max(size.width / aspectRatio, minHeight) + 'px';
			},

			_separateDatasetLabels: function (data) {
				var datasets = data.data.datasets;

				data.data.datasets = datasets.map(module._separateDatasetLabel);

				return data;
			},

			_separateDatasetLabel: function (dataset) {
				var newDataset = {};

				newDataset.label = dataset.splice(0, 1);
				newDataset.data = dataset;

				return newDataset;
			},

			bar: {
				_transformData: function (data) {
					data = module.bar._buildAxisLabels(data);
					data = module.bar._applyColours(data);

					return data;
				},

				_buildAxisLabels: function (data) {
					var scales = {
						yAxes: [
							{
								scaleLabel: {
									display: true,
									labelString: data.yAxisLabel
								}
							}
						],
						xAxes: [
							{
								scaleLabel: {
									display: true,
									labelString: data.xAxisLabel
								}
							}
						]
					};

					data.options = data.options || {};

					data.options.scales = scales;

					return data;
				},

				_applyColours: function (data) {
					var datasets = data.data.datasets;

					datasets.forEach(module.bar._applyColour);

					return data;
				},

				_applyColour: function (dataset, i) {
					dataset.backgroundColor = module._getColour(i);
				}
			},

			doughnut: {
				_transformData: function (data) {
					data = module.doughnut._ignoreExtraDatasets(data);
					data = module.doughnut._applyColours(data);

					return data;
				},

				_ignoreExtraDatasets: function (data) {
					var datasets = data.data.datasets;

					datasets = datasets.splice(0, 1);
					data.data.datasets = datasets;

					return data;
				},

				_applyColours: function (data) {
					var dataset = data.data.datasets[0];
					var dataPoints = dataset.data;

					dataPoints.forEach(module.doughnut._applyColour(dataset));

					return data;
				},

				_applyColour: function (dataset) {
					return function (dataPoint, i) {
						dataset.backgroundColor = dataset.backgroundColor || [];
						dataset.backgroundColor.push(module._getColour(i));
					};
				}
			},

			_getColour: function (i) {
				return colours[i % colours.length];
			}
		};

		return {
			init: module.init
		};
	}
);
